angular.module('frontend-ra-consumer').run(function($templateCache) {
    // @ngInject
    _.forEach(__TEMPLATE_CACHE__, (content, filename) => $templateCache.put(filename, content));
});
